import React from 'react'
import classNames from 'classnames'
import { getTypeId } from 'training-lane-booking-shared/utilities/functions'
import counterClasses from './Counter.module.scss'

const Wrapper = ({ children, landingPage }) => landingPage
    ? <div className={counterClasses.counterLabelLong}>{children}</div>
    : (
        <>
            <span className={counterClasses.counterLabel}>{children}</span>
            <br />
        </>
    )

const Counter = ({
    adminView = false,
    adminMemberList = false,
    creditsLoading = false,
    credits,
    type,
    currentIndex,
    handleCounterClick = () => {},
    tempCreditActive = false,
    isStaff = false,
    typesLength = 4,
    disabled = false,
    landingPage = false
}) => {
    const label = landingPage
        ? [
            type.description.peopleShort,
            type.description.categoryShort
        ].filter(Boolean).join(' ') || type.label.long
        : type.label.short

    const buttonClasses = classNames(
        'button', counterClasses.bcButton, counterClasses.hvrRippleOut,
        {
            [counterClasses.hvrRippleOutBlue]: type.category === 'lane',
            [counterClasses.hvrRippleOutChelle]: type.id === getTypeId('tlc'),
            [counterClasses.hvrRippleOutRed]: type.category === 'ir' && type.id !== 'tlc',
            [counterClasses.hvrBackPulse]: tempCreditActive,
            [counterClasses.hvrBackPulseAnimateBlue]: type.category === 'lane' && tempCreditActive,
            [counterClasses.hvrBackPulseAnimateChelle]: type.id === getTypeId('tlc'),
            [counterClasses.hvrBackPulseAnimateRed]: type.category === 'ir' && type.id !== 'tlc' && tempCreditActive,
            [counterClasses.hvrBackPulseAnimate]: tempCreditActive && !isStaff,
            'disabled': creditsLoading || disabled
        }
    )

    // noinspection JSCheckFunctionSignatures
    return (
        <>
            <div
                className={classNames(
                    {
                        'col-1': !adminView && !landingPage,
                        'col-2': adminView && (typesLength >= 6 || typesLength === 5),
                        'col-3': adminView && typesLength === 4,
                        'col-5': landingPage,
                        [`col-${12 / typesLength}`]: adminMemberList
                    },
                    counterClasses.counterWrapper,
                    landingPage && counterClasses.counterWrapperLandingPage
                )}
                onClick={e => handleCounterClick(e, type)}
                onKeyUp={handleCounterClick}
                role="button"
                tabIndex="-1">
                <Wrapper landingPage={landingPage}>
                    {label}
                </Wrapper>
                <button className={buttonClasses}>
                    {creditsLoading || disabled ? 0 : credits[type.id] || 0}
                </button>
            </div>
            {landingPage && currentIndex % 2 === 0 ? (
                <div className="col-2">&nbsp;</div>
            ) : null}
        </>
    )
}

export default Counter
